import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import useSettings from "../../hooks/useSettings";
import { getBackendUrl } from "../../config";
import { getPublicLandingSections } from "../../services/landingSectionsService";
import logoImage from "../../assets/logolp.png";

const NAV_CSS = `
  .lp-nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 1000;
    background: rgba(255,255,255,0.82);
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    border-bottom: 1px solid rgba(229,231,235,0.7);
    height: 72px;
    display: flex; align-items: center;
    transition: box-shadow .35s ease, background .35s ease;
  }
  .lp-nav--scrolled {
    background: rgba(255,255,255,0.97);
    box-shadow: 0 2px 48px rgba(0,0,0,0.07);
    border-bottom-color: rgba(229,231,235,0.9);
  }
  .lp-nav__wrap {
    max-width: 1240px; margin: 0 auto; padding: 0 40px;
    width: 100%; display: flex; align-items: center; justify-content: space-between;
    gap: 24px;
  }
  .lp-nav__brand {
    display: flex; align-items: center; gap: 10px; cursor: pointer;
    flex-shrink: 0; text-decoration: none;
  }
  .lp-nav__logo { height: 34px; width: auto; display: block; }
  .lp-nav__brand-name {
    font-size: 18px; font-weight: 800; color: #0a0a1a;
    letter-spacing: -.4px; white-space: nowrap;
  }
  .lp-nav__menu {
    display: flex; gap: 2px; list-style: none; margin: 0; padding: 0;
    flex: 1; justify-content: center;
  }
  .lp-nav__item button {
    background: none; border: none; color: var(--lp-nav-text, #64748b);
    font-size: 14px; font-weight: 500; cursor: pointer;
    transition: color .2s, background .2s;
    padding: 7px 14px; border-radius: 8px; font-family: inherit;
    white-space: nowrap;
  }
  .lp-nav__item button:hover { color: #2563EB; background: rgba(37, 99, 235,.07); }
  .lp-nav__right { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }
  .lp-btn-ghost {
    background: none; border: 1px solid #e2e8f0; color: #374151;
    padding: 9px 20px; border-radius: 10px; font-size: 14px;
    font-weight: 500; cursor: pointer; transition: all .2s; font-family: inherit;
    white-space: nowrap;
  }
  .lp-btn-ghost:hover { border-color: #2563EB; color: #2563EB; background: rgba(37, 99, 235,.05); }
  .lp-btn-grad {
    background: linear-gradient(135deg, #2563EB 0%, #2563eb 100%);
    color: #fff; border: none;
    padding: 10px 22px; border-radius: 10px;
    font-size: 14px; font-weight: 600; cursor: pointer; font-family: inherit;
    transition: opacity .2s, transform .2s, box-shadow .2s;
    box-shadow: 0 4px 18px rgba(37, 99, 235,.3);
    white-space: nowrap;
  }
  .lp-btn-grad:hover { opacity: .88; transform: translateY(-1px); box-shadow: 0 8px 28px rgba(37, 99, 235,.4); }

  /* Hamburger */
  .lp-nav__hamburger {
    display: none;
    background: none; border: 1px solid #e2e8f0;
    cursor: pointer; padding: 9px; color: #374151;
    flex-shrink: 0; border-radius: 9px;
    transition: border-color .2s, color .2s;
    align-items: center; justify-content: center;
  }
  .lp-nav__hamburger:hover { border-color: #2563EB; color: #2563EB; }

  /* Drawer overlay */
  .lp-nav__drawer {
    display: none;
    position: fixed; top: 72px; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.45);
    z-index: 999;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
  }
  .lp-nav__drawer--open { display: block; }
  .lp-nav__drawer-panel {
    background: #fff;
    padding: 8px 0 24px;
    display: flex; flex-direction: column;
    border-bottom-left-radius: 28px;
    border-bottom-right-radius: 28px;
    box-shadow: 0 24px 64px rgba(0,0,0,.18);
    max-height: calc(100vh - 72px);
    overflow-y: auto;
  }
  .lp-nav__drawer-item button {
    width: 100%; text-align: left;
    background: none; border: none;
    padding: 13px 24px;
    font-size: 15px; font-weight: 500;
    color: var(--lp-nav-text, #374151);
    cursor: pointer; font-family: inherit;
    transition: color .15s, background .15s;
  }
  .lp-nav__drawer-item button:hover { color: #2563EB; background: rgba(37, 99, 235,.05); }
  .lp-nav__drawer-divider {
    height: 1px; background: #f1f5f9; margin: 8px 0;
  }
  .lp-nav__drawer-btns {
    display: flex; flex-direction: column; gap: 10px;
    padding: 12px 16px 16px;
    position: sticky; bottom: 0;
    background: #fff;
    border-top: 1px solid #f1f5f9;
  }
  .lp-nav__drawer-btns .lp-btn-ghost,
  .lp-nav__drawer-btns .lp-btn-grad {
    width: 100%; padding: 13px 20px; font-size: 15px;
    text-align: center; border-radius: 12px;
    display: block; text-decoration: none;
    touch-action: manipulation; -webkit-tap-highlight-color: transparent;
  }

  @media (max-width: 860px) {
    .lp-nav__menu { display: none; }
    .lp-nav__right { display: none; }
    .lp-nav__hamburger { display: flex; }
    .lp-nav__wrap { padding: 0 20px; }
  }
`;

const LandingHeader = ({ scrollTo }) => {
  const history = useHistory();
  const { getPublicSetting } = useSettings();
  const [siteLogo, setSiteLogo] = useState(undefined);
  const [appName, setAppName] = useState("");
  const [headerData, setHeaderData] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [allowSignup, setAllowSignup] = useState(true);

  useEffect(() => {
    getPublicSetting("userCreation")
      .then(v => setAllowSignup(v !== "disabled"))
      .catch(() => {});
    getPublicSetting("appName").then(v => { if (v) setAppName(v); }).catch(() => {});
    getPublicSetting("appLogoSite").then(v => {
      setSiteLogo(v ? getBackendUrl() + "/public/" + v : null);
    }).catch(() => { setSiteLogo(null); });
    getPublicLandingSections()
      .then(data => { if (data?.header) setHeaderData(data.header); })
      .catch(() => {});
  }, []);

  /* preview em tempo real: recebe postMessage do admin */
  useEffect(() => {
    const handler = (e) => {
      if (e.data?.type === "LP_PREVIEW_UPDATE" && e.data?.data?.header !== undefined) {
        setHeaderData(e.data.data.header || null);
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 860) setDrawerOpen(false); };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const h = (field, def) => headerData?.[field] || def;
  const hc = (field) => headerData?.[field] || "";

  const navItems = [
    { label: h("nav1Label", "Funcionalidades"), link: h("nav1Link", "#features") },
    { label: h("nav2Label", "Integrações"), link: h("nav2Link", "#integrations") },
    { label: h("nav3Label", "Planos"), link: h("nav3Link", "#pricing") },
    { label: h("nav4Label", "FAQ"), link: h("nav4Link", "#faq") },
    ...(h("nav5Label", "") ? [{ label: h("nav5Label", "Blog"), link: h("nav5Link", "#blog") }] : [{ label: "Blog", link: "#blog" }]),
  ];

  const handleNavClick = (link) => {
    setDrawerOpen(false);
    if (!link) return;
    if (link.startsWith("#")) {
      scrollTo && scrollTo(link.substring(1));
    } else {
      history.push(link);
    }
  };

  const navTextColor = hc("navTextColor");
  const loginTextColor = hc("btnLoginTextColor");
  const loginBgColor = hc("btnLoginBgColor");
  const loginBorderColor = hc("btnLoginBorderColor");
  const cadastroTextColor = hc("btnCadastroTextColor");
  const cadastroBgFrom = hc("btnCadastroBgFrom");
  const cadastroBgTo = hc("btnCadastroBgTo");

  const hoverAccent          = hc("hoverAccentColor");
  const loginHoverText       = hc("btnLoginHoverTextColor");
  const loginHoverBg         = hc("btnLoginHoverBgColor");
  const loginHoverBorder     = hc("btnLoginHoverBorderColor");
  const cadastroHoverText    = hc("btnCadastroHoverTextColor");
  const cadastroHoverBgFrom  = hc("btnCadastroBgHoverFrom");
  const cadastroHoverBgTo    = hc("btnCadastroBgHoverTo");

  const hoverOverrideCSS = [
    hoverAccent && `
      .lp-nav__item button:hover { color: ${hoverAccent} !important; background: ${hoverAccent}14 !important; }
      .lp-nav__drawer-item button:hover { color: ${hoverAccent} !important; background: ${hoverAccent}0d !important; }
      .lp-nav__hamburger:hover { color: ${hoverAccent} !important; border-color: ${hoverAccent} !important; }
      .lp-btn-ghost:hover { color: ${hoverAccent} !important; border-color: ${hoverAccent} !important; background: ${hoverAccent}0d !important; }
    `,
    loginHoverText   && `.lp-btn-ghost:hover { color: ${loginHoverText} !important; }`,
    loginHoverBg     && `.lp-btn-ghost:hover { background: ${loginHoverBg} !important; }`,
    loginHoverBorder && `.lp-btn-ghost:hover { border-color: ${loginHoverBorder} !important; }`,
    cadastroHoverText && `.lp-btn-grad:hover { color: ${cadastroHoverText} !important; }`,
    (cadastroHoverBgFrom || cadastroHoverBgTo) && `.lp-btn-grad:hover { background: linear-gradient(135deg, ${cadastroHoverBgFrom || "#2563EB"} 0%, ${cadastroHoverBgTo || "#2563eb"} 100%) !important; opacity: 1 !important; }`,
  ].filter(Boolean).join("\n");

  const loginStyle = {
    ...(loginTextColor ? { color: loginTextColor } : {}),
    ...(loginBgColor ? { background: loginBgColor } : {}),
    ...(loginBorderColor ? { borderColor: loginBorderColor } : {}),
  };
  const cadastroStyle = {
    ...(cadastroTextColor ? { color: cadastroTextColor } : {}),
    ...(cadastroBgFrom || cadastroBgTo ? {
      background: `linear-gradient(135deg, ${cadastroBgFrom || "#2563EB"} 0%, ${cadastroBgTo || "#2563eb"} 100%)`
    } : {}),
  };

  return (
    <>
      <style>{NAV_CSS}</style>
      {hoverOverrideCSS && <style>{hoverOverrideCSS}</style>}
      <nav
        className={`lp-nav${scrolled ? " lp-nav--scrolled" : ""}`}
        style={navTextColor ? { "--lp-nav-text": navTextColor } : undefined}
      >
        <div className="lp-nav__wrap">
          {/* Brand */}
          <div
            className="lp-nav__brand"
            onClick={() => scrollTo ? scrollTo("hero") : history.push("/")}
          >
            {siteLogo !== undefined && (
              <img src={siteLogo || logoImage} alt={appName} className="lp-nav__logo" />
            )}
          </div>

          {/* Desktop nav */}
          <ul className="lp-nav__menu">
            {navItems.map((item, i) => (
              <li key={i} className="lp-nav__item">
                <button onClick={() => handleNavClick(item.link)}>{item.label}</button>
              </li>
            ))}
          </ul>

          {/* Desktop actions */}
          <div className="lp-nav__right">
            <button
              className="lp-btn-ghost"
              style={loginStyle}
              onClick={() => { window.location.href = "https://app.floow.chat/login"; }}
            >
              {h("btnLoginLabel", "Entrar")}
            </button>
            {allowSignup && (
              <button
                className="lp-btn-grad"
                style={cadastroStyle}
                onClick={() => { window.location.href = "https://app.floow.chat/cadastro"; }}
              >
                {h("btnCadastroLabel", "Começar agora")}
              </button>
            )}
          </div>

          {/* Mobile hamburger */}
          <button
            className="lp-nav__hamburger"
            onClick={() => setDrawerOpen(v => !v)}
            aria-label="Menu"
          >
            {drawerOpen
              ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            }
          </button>
        </div>
      </nav>

      {/* Mobile drawer */}
      <div
        className={`lp-nav__drawer${drawerOpen ? " lp-nav__drawer--open" : ""}`}
        onClick={() => setDrawerOpen(false)}
      >
        <div
          className="lp-nav__drawer-panel"
          onClick={e => e.stopPropagation()}
          style={navTextColor ? { "--lp-nav-text": navTextColor } : undefined}
        >
          {navItems.map((item, i) => (
            <div key={i} className="lp-nav__drawer-item">
              <button onClick={() => handleNavClick(item.link)}>{item.label}</button>
            </div>
          ))}
          <div className="lp-nav__drawer-divider" />
          <div className="lp-nav__drawer-btns">
            {/* Navegação explícita pro app (evita cancelamento ao fechar o drawer no mobile) */}
            <a
              href="https://app.floow.chat/login"
              className="lp-btn-ghost"
              style={loginStyle}
              onClick={(e) => { e.preventDefault(); setDrawerOpen(false); window.location.href = "https://app.floow.chat/login"; }}
            >
              {h("btnLoginLabel", "Entrar")}
            </a>
            {allowSignup && (
              <a
                href="https://app.floow.chat/cadastro"
                className="lp-btn-grad"
                style={cadastroStyle}
                onClick={(e) => { e.preventDefault(); setDrawerOpen(false); window.location.href = "https://app.floow.chat/cadastro"; }}
              >
                {h("btnCadastroLabel", "Começar agora")}
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingHeader;
